import React from 'react'
import GoogleMapReact from 'google-map-react'

const settings = {
  center: {
    lat: 39.0997,
    lng: -94.5786
  },
  zoom: 10,
}

export default function Map(props) {
  return (
    <div>
      <div style={{ height: 'calc(100vh - 64px)' }}>
        <GoogleMapReact
          id="map"
          bootstrapURLKeys={{ key: 'AIzaSyAK4sz2iwYm0tK1_TQkEuoJHZI5R0_DIcA' }}
          defaultCenter={settings.center}
          defaultZoom={settings.zoom}
        >
          {props.markers}
          {props.nearMarkers}
          {props.searchMarker}

        </GoogleMapReact>
      </div>
    </div>
  )
}